import { config } from '../domain/config'

export async function googleApi<T>(action: string, payload: Record<string, unknown> = {}, idToken?: string): Promise<T> {
  if (!config.apiUrl) throw new Error('Falta VITE_APPS_SCRIPT_API_URL.')
  const response = await fetch(config.apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({ action, ...payload, idToken }),
    redirect: 'follow',
  })
  if (!response.ok) throw new Error(`Apps Script respondió ${response.status}.`)
  const result = await response.json() as { ok: boolean; data?: T; error?: string }
  if (!result.ok) throw new Error(result.error || 'Error desconocido del backend.')
  return result.data as T
}
